import { SortingOptions } from './utils';

export const sortBy = (
  array: any[],
  increase: SortingOptions = 'asc',
  attribute: string,
  ignoreNull?: boolean,
  asNumber?: boolean
) =>
  array.slice().sort((a: any, b: any) => {
    const aAttribute = asNumber ? Number(a[attribute]) : a[attribute];
    const bAttribute = asNumber ? Number(b[attribute]) : b[attribute];

    if (ignoreNull) {
      if (
        (aAttribute === undefined || aAttribute === null) &&
        (bAttribute === undefined || bAttribute === null)
      ) {
        return 0;
      }
      if (aAttribute === undefined || aAttribute === null) {
        return increase === 'asc' ? 1 : -1;
      }
      if (bAttribute === undefined || bAttribute === null) {
        return increase === 'asc' ? -1 : 1;
      }
    }
    if (aAttribute > bAttribute) {
      return increase === 'asc' ? 1 : -1;
    }
    if (aAttribute < bAttribute) {
      return increase === 'asc' ? -1 : 1;
    }

    return 0;
  });
